import { writable } from 'svelte/store';

export const dolphinRoomOpen = writable(false);
